import { Component, Input } from '@angular/core';
import { VersionHistoryChangesPanelComponent } from '@components/version-history-changes-panel/version-history-changes-panel.component';
import { ChangesObject } from 'icreate/common/models/versions-history';

@Component({
    selector: 'app-channel-group-changes-panel',
    templateUrl: './channel-group-changes-panel.component.html',
    styleUrls: ['../version-history-changes-panel/version-history-changes-panel.component.css'],
    standalone: false,
})
export class ChannelGroupChangesPanelComponent extends VersionHistoryChangesPanelComponent {
    @Input() changes: ChangesObject;
}
